import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a05439a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "ARTWORKS IN YOUR ACCOUNT")
], -1))
const _hoisted_3 = {
  key: 1,
  class: "info-container"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info" }, " Move your Artworks around by dragging and dropping them into your preferred order! ", -1))
const _hoisted_5 = { class: "artworks-container" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoader = _resolveComponent("SpinnerLoader")!
  const _component_ArtworkImagePopup = _resolveComponent("ArtworkImagePopup")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_InsideSearch = _resolveComponent("InsideSearch")!
  const _component_ArtworkCard = _resolveComponent("ArtworkCard")!
  const _component_Draggable = _resolveComponent("Draggable")!
  const _component_Container = _resolveComponent("Container")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_MainLayout = _resolveComponent("MainLayout")!

  return (_openBlock(), _createBlock(_component_MainLayout, null, {
    default: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_SpinnerLoader, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.isOpen)
              ? (_openBlock(), _createBlock(_component_ArtworkImagePopup, {
                  key: 0,
                  artwork: _ctx.getArtworkId(),
                  show: _ctx.isOpen,
                  onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpen = false))
                }, null, 8, ["artwork", "show"]))
              : _createCommentVNode("", true),
            _hoisted_2,
            _createVNode(_component_v_divider),
            _createVNode(_component_InsideSearch, {
              button: "Add Artwork",
              onSearch: _ctx.filterArtworks
            }, null, 8, ["onSearch"]),
            _createVNode(_component_v_divider),
            (!_ctx.isPrivateSeller)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("div", {
                    style: {"cursor":"pointer"},
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveOrder && _ctx.saveOrder(...args)))
                  }, [
                    _createTextVNode(" Save Order "),
                    (_ctx.isSaving)
                      ? (_openBlock(), _createBlock(_component_SpinnerLoader, {
                          key: 0,
                          color: 'white',
                          class: "save-loader"
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_divider),
            _createElementVNode("section", _hoisted_5, [
              (!_ctx.isPrivateSeller)
                ? (_openBlock(), _createBlock(_component_Container, {
                    key: 0,
                    orientation: "vertical",
                    onDrop: _ctx.onDrop
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredArtworks, (artwork) => {
                        return (_openBlock(), _createBlock(_component_Draggable, {
                          key: artwork.id
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ArtworkCard, {
                              artwork: artwork,
                              role: _ctx.role,
                              draggable: "",
                              onMoveUp: ($event: any) => (_ctx.moveUp(artwork.id)),
                              onMoveDown: ($event: any) => (_ctx.moveDown(artwork.id)),
                              onDuplicate: ($event: any) => (_ctx.duplicateArtwork(artwork.id)),
                              onDisplayImages: ($event: any) => {
                _ctx.popupId = artwork.id;
                _ctx.isOpen = true;
              }
                            }, null, 8, ["artwork", "role", "onMoveUp", "onMoveDown", "onDuplicate", "onDisplayImages"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["onDrop"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredArtworks, (artwork) => {
                      return (_openBlock(), _createBlock(_component_ArtworkCard, {
                        key: artwork.id,
                        artwork: artwork,
                        role: _ctx.role,
                        draggable: "",
                        onMoveUp: ($event: any) => (_ctx.moveUp(artwork.id)),
                        onMoveDown: ($event: any) => (_ctx.moveDown(artwork.id)),
                        onDuplicate: ($event: any) => (_ctx.duplicateArtwork(artwork.id)),
                        onDisplayImages: ($event: any) => {
              _ctx.popupId = artwork.id;
              _ctx.isOpen = true;
            }
                      }, null, 8, ["artwork", "role", "onMoveUp", "onMoveDown", "onDuplicate", "onDisplayImages"]))
                    }), 128))
                  ]))
            ]),
            (_ctx.isGalleryOrPrivateSeller)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_ctx.artworksLength.length > _ctx.limit)
                    ? (_openBlock(), _createBlock(_component_PaginationComponent, {
                        key: 0,
                        pageSize: _ctx.pageSize,
                        data: _ctx.length,
                        "current-page": _ctx.currentPage,
                        onPageChanged: _ctx.updatePagination
                      }, null, 8, ["pageSize", "data", "current-page", "onPageChanged"]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_PaginationComponent, {
                    pageSize: _ctx.pageSize,
                    data: _ctx.length,
                    "current-page": _ctx.currentPage,
                    onPageChanged: _ctx.updatePagination
                  }, null, 8, ["pageSize", "data", "current-page", "onPageChanged"])
                ]))
          ]))
    ]),
    _: 1
  }))
}